import 'angular';

import { CashDepositCtrl }       from './customer.cash-deposit';
import { DepositCtrl }           from './deposit.ajs';
import { InvoiceDepositService } from './deposits.services';

angular.module('workshop.invoices.deposits', [])
  .controller('CashDepositCtrl', CashDepositCtrl)
  .controller('DepositCtrl', DepositCtrl)
  .factory('Deposit', InvoiceDepositService);